import { Div, Span, Ref, Button } from "@tblabs/truffle";
import { InfoBox } from "../Components/InfoBox";


export class Page extends Div
{
    public body: Div;
    private loader = new Span("Ładowanie strony...");

    constructor(private pageTitle: string, cssClasses: string = "")
    {
        super(cssClasses);

        this.SetTitle(this.pageTitle);

        this.body = new Div("");

        this.Append(
            new Div().WidthPercent(100).TextAlignCenter()
                .Append(this.body)
        );
    }

    protected SetTitle(title: string | Ref<string>)
    {
        document.title = title instanceof Ref ? title.value : title || "specTeam.pl";
    }

    private onError = (ex: Error) => { return ({ header: "Błąd", body: ex.message }) };
    public OnError(handler: (ex: Error) => { header: string, body: string }): void
    {
        this.onError = handler;
    }

    public async Content(content: (body: Div) => Promise<void>): Promise<void>
    {
        try
        {
            this.Append(this.loader);

            await content(this.body);
        }
        catch (ex: any)
        {
            console.error(ex);

            let problemHeader = "Błąd";
            let problemBody = ex.message;
            const msg = ex.message.toLowerCase();

            if (msg.includes("unauthorized"))
            {
                problemHeader = "Brak autoryzacji";
                problemBody = new Button("Zaloguj", () => window.location.hash = "login");
            }
            else if (msg.includes("failed to fetch"))
            {
                problemHeader = "Problem z połączeniem";
                problemBody = "Sprawdź swoje połączenie z internetem i odśwież stronę";
            }
            else 
            {
                const onErrorResult = this.onError(ex as Error);
                problemHeader = onErrorResult.header;
                problemBody = onErrorResult.body;
            }

            this.body.Append(
                new InfoBox(problemHeader, problemBody)
            );
        }
        finally
        {
            this.loader.RemoveSelf();
        }
    }
}
